<template>
    <div class="m-viewport" v-if="ready">

        <div class="logo-view">
          <h2 class="logo_1"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
          <h2 class="logo_2"><a href="https://www.m3guo.com/activity/202309/preheat-lcoa/" target="_blank" rel="noopener noreferrer"></a></h2>
        </div>

        <div class="u-links">
            <div class="btn-index">
                <a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a>
            </div>
            <div class="btn-dl">
              <a href="https://www.m3guo.com/v2/download/client/" target="_blank" rel="noopener noreferrer"></a>
            </div>
        </div>        

        <div class="main-title"></div>
        <div class="u-btn reward-detail" @click="$reward_modal()"></div>

        <div class="i-md"></div>

        <div class="wrapper">
            <team class="c-team" ref="team"/>
            <task class="c-task" ref="task"/>
            <corp class="c-corp"/>
            <rule class="c-rule"/>
        </div>        
    </div>
</template>

<style lang="scss" scoped>
.m-viewport{
    //pc
    @media screen and (min-width: 900px) {
        position: relative;
        width: 100%;
        max-width: 1920px;
        height: 5648px;
        margin: 0 auto;
        padding-top: 906px;
        /* overflow: hidden; */
        overflow-x: hidden;
        background-image: url(~@/assets/images/pc/body.jpg);
        background-position: center top;
        background-repeat: no-repeat;    
        background-color: #222229;
        box-sizing: border-box;

        .logo-view{
            display: flex;
            align-items: center;
            position: absolute;
            left: 2%;
            top: 10px;
        }

        .logo-view a{
            display: block;
            width: 100%;
            height: 100%;
        }

        .logo-view .logo_1{
            width: 124px;
            height: 98px;
            background-image: url(~@/assets/images/pc/logo_1.png);
        }

        .logo-view .logo_2{
            width: 96px;
            height: 96px;
            margin-left: 20px;
            background-image: url(~@/assets/images/pc/logo_2.png);
        }

        .u-links{
            display: flex;
            position: absolute;
            right: 2%;
            top: 30px;    
        }

        .btn-index{
            width: 130px;
            height: 42px;
            margin-right: 10px;
            background-image: url(~@/assets/images/pc/btn-index.png);
        }

        .btn-dl{
            width: 130px;
            height: 42px;
            background-image: url(~@/assets/images/pc/btn-dl.png);
        }

        .u-links a{
            display: block;
            width: 100%;
            height: 100%;
        }
        
        .reward-detail{
            position: absolute;
            left: 50%;
            top: 406px;
            width: 314px;
            height: 124px;
            margin-left: -157px;
            background-image: url(~@/assets/images/pc/btn-reward_list.png);
        }

        .i-md{
            position: absolute;
            left: 50%;
            top: 740px;
            width: 112px;
            height: 48px;
            background-image: url(~@/assets/images/pc/notice-md.png);
            margin-left: -56px;
            animation:arrowLLoop 2s linear infinite;
            z-index: 5;
        }

        .main-title{
            position: absolute;
            left: 50%;
            top: 104px;
            width: 1103px;
            height: 260px;
            margin-left: -551.5px;
            background-image: url(~@/assets/images/pc/main-title.png);           
        }

        .c-task{
            margin-top: 135px;
        }

        .c-corp{
            margin-top: 150px;
        }

        .c-rule{
            margin-top: 90px;
        }
    }
    
    //mobile
    @media screen and (max-width: 899px) {}
}
</style>

<script>
import team from '@/components/views/team'
import task from '@/components/views/task'
import corp from '@/components/views/corp'
import rule from '@/components/views/evtrule'

export default {
    components: {
        team,
        task,
        corp,
        rule,
    },     
    data (){
        return {
            compare : false,
        }
    },
    mounted (){
        console.log(this.$store.state)
    },
    props :{
        ready : {
            default : false,
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/index/index.vue